
// custom
import {
    GET_LIST,
    GET_ONE,
    CREATE,
    UPDATE,
    DELETE,
    DELETE_MANY,
    MOVE_MANY,
    RESET
} from 'store/actions/fetchActions';

export const CRUD_GET_LIST = 'CRUD_GET_LIST';
export const CRUD_GET_LIST_SUCCESS = 'CRUD_GET_LIST_SUCCESS';

export const CRUD_GET_ONE = 'CRUD_GET_ONE';
export const CRUD_GET_ONE_SUCCESS = 'CRUD_GET_ONE_SUCCESS';

export const CRUD_CREATE = 'CRUD_CREATE';
export const CRUD_CREATE_SUCCESS = 'CRUD_CREATE_SUCCESS';
export const CRUD_CREATE_FAILURE = 'CRUD_CREATE_FAILURE';

export const CRUD_UPDATE = 'CRUD_UPDATE';
export const CRUD_UPDATE_SUCCESS = 'CRUD_UPDATE_SUCCESS';

export const CRUD_DELETE = 'CRUD_DELETE';
export const CRUD_DELETE_SUCCESS = 'CRUD_DELETE_SUCCESS';

export const CRUD_DELETE_MANY = 'CRUD_DELETE_MANY';
export const CRUD_DELETE_MANY_SUCCESS = 'CRUD_DELETE_MANY_SUCCESS';
export const CRUD_DELETE_MANY_FAILURE = 'CRUD_DELETE_MANY_FAILURE';

export const CRUD_MOVE_MANY = 'CRUD_MOVE_MANY';
export const CRUD_MOVE_SUCCESS = 'CRUD_MOVE_MANY_SUCCESS';

export const CRUD_RESET = 'CRUD_RESET';

/**
 * Action 정의
 * type : 작업의 종류 (성공 혹은 실패 시 type값_SUCCESS, type값_FAILURE 액션이 발생)
 * payload : http 통신할 때 사용할 파라미터값
 * meta
 *  - menu : 호출한 메뉴의 정보 (ex. MAIL / AUTOREPLY)
 *  - fetch : fetch구분값 (ex. GET_LIST / GET_ONE)
 *      => 호출할 URI의 정보는 menu값_fetch값으로 구함
 *  - fetchMethod : http 통신에서 사용할 method ( default : 'get' )
 *  - popup : 성공 또는 실패 시 action이 Dialog창에 적용될 것인지 메인창에 적용될 것인지 설정 ( default : false )
 *  - onSuccess: 성공할 경우의 동작 정의 
 *      - notification : 알림 메세지
 *          - requestMsgArgs : 메세지를 만들때 필요한 값을 같이 전달하기 위한 목적
 *      - unselectAll : 체크박스 해제 
 *      - refresh : 새로고침 
 *          => notification/unselectAll/refresh 모두 popup값을 가질 수 있으며 popup값이 정의되어 있지 않은 경우 meta.popup값 적용
 *  - onFailure: 실패할 경우의 동작 정의 
 *      => onSuccess와 구조 동일
 */

 /**
 * 목록 조회 action (메일 목록/...)
 * @param {string} menu : 'MAIL' or 'ADDR'
 * @param {Object} params : request요청 시 보낼 파라미터 
 */
export const crudGetList = (menu, params) => ({
    type: CRUD_GET_LIST,
    payload: { params },
    meta: {
        menu: menu.toUpperCase(),
        fetch: GET_LIST,
        fetchMethod: 'get',
        onSuccess: {
            unselectAll: {},
        },
        onFailure: {
            notification: {
                body: "common.get.list.failure",
                level: 'warning',
            },
        },
    },
});

/**
 * 하나의 데이타를 조회하는 action
 * @param {string} menu : MAIL/FORWARDING/AUTOREPLY/ADDR
 * @param {Object} params : request요청 시 보낼 파라미터 
 */
export const crudGetOne = (menu, params, options) => ({
    type: CRUD_GET_ONE,
    payload: { params },
    meta: {
        menu: menu.toUpperCase(),
        fetch: GET_ONE,
        fetchMethod: 'get',
        popup: options && options.isPopup ? true : false,
        loading: options && options.isLoading ? true : false,
        onFailure: {
            notification: {
                body: "common.get.one.failure",
                level: 'warning',
            },
        },
    },
});

/**
 * 데이타를 저장하는 action 
 * @param {string} menu : MAIL/FORWARDING/AUTOREPLY/ADDR
 * @param {Object} params : request요청 시 보낼 파라미터 
 */
export const crudCreate = (menu, params, isPopup) => ({
    type: CRUD_CREATE,
    payload: { params },
    meta: {
        menu: menu.toUpperCase(),
        fetch: CREATE,
        fetchMethod: 'post',
        popup: isPopup ? true : false,
        onSuccess: {
            notification: {
                body: "common.save.success",
                level: 'info',
                popup: false,
            },
            refresh: {
                popup: false,
            }
        },
        onFailure: {
            notification: {
                body: "common.save.failure",
                level: 'warning',
            },
        },
    },
});

/**
 * 데이타를 저장하는 action (성공 시 redirect - 본문 전용 action)
 * @param {string} menu : 메뉴명 (ex. company.mailgroup)
 * @param {Object} params : request요청 시 보낼 파라미터 
 */
export const crudCreateWithRedirect = (menu, params, redirectTo) => ({
    type: CRUD_CREATE,
    payload: { params },
    meta: {
        menu: menu.toUpperCase(),
        fetch: CREATE,
        fetchMethod: 'post',
        popup: false,
        onSuccess: {
            notification: {
                body: "common.save.success",
                level: 'info',
                popup: false,
            },
            redirectTo: redirectTo,
        },
        onFailure: {
            notification: {
                body: "common.save.failure",
                level: 'warning',
            },
        },
    },
});

/**
 * 데이타를 업데이트하는 action (성공 시 본문 refresh)
 * @param {string} menu : MAIL/FORWARDING/AUTOREPLY/ADDR
 * @param {Object} params : request요청 시 보낼 파라미터 
 */
export const crudUpdate = (menu, params, isPopup) => ({
    type: CRUD_UPDATE,
    payload: { params },
    meta: {
        menu: menu.toUpperCase(),
        fetch: UPDATE,
        fetchMethod: 'post',
        popup: isPopup ? true : false,
        onSuccess: {
            notification: {
                body: "common.save.success",
                level: 'info',
                popup: false,
            },
            refresh: {
                popup: false,
            }
        },
        onFailure: {
            notification: {
                body: "common.save.failure",
                level: 'warning',
            },
        },
    },
});


/**
 * 데이타를 업데이트하는 action (성공 시 redirect - 본문 전용 action)
 * @param {string} menu : MAIL/FORWARDING/AUTOREPLY/ADDR
 * @param {Object} params : request요청 시 보낼 파라미터 
 */
export const crudUpdateWithRedirect = (menu, params, redirectTo) => ({
    type: CRUD_UPDATE,
    payload: { params },
    meta: {
        menu: menu.toUpperCase(),
        fetch: UPDATE,
        fetchMethod: 'post',
        popup: false,
        onSuccess: {
            notification: {
                body: "common.save.success",
                level: 'info',
                popup: false,
            },
            redirectTo: redirectTo,
        },
        onFailure: {
            notification: {
                body: "common.save.failure",
                level: 'warning',
            },
        },
    },
});

/**
 * 데이타를 업데이트하는 action (crudUpdate와 차이점 - 성공에 대한 액션정보가 없음)
 * @param {string} menu : ex. CONTACT_IMPORT
 * @param {Object} params : request요청 시 보낼 파라미터 
 */
export const crudUpdateWithoutSuccessAction = (menu, params, isPopup) => ({
    type: CRUD_UPDATE,
    payload: { params },
    meta: {
        menu: menu.toUpperCase(),
        fetch: UPDATE,
        fetchMethod: 'post',
        popup: isPopup ? true : false,
        onFailure: {
            notification: {
                body: "common.save.failure",
                level: 'warning',
            },
        },
    },
});


/**
 * 하나의 데이타 삭제 action
 * @param {string} menu : 'MAIL' or 'ADDR'
 * @param {Object} params : request요청 시 보낼 파라미터 
 * @param {Object} redirectTo : 성공 시 이동할 Link정보
 */
export const crudDelete = (menu, params, redirectTo) => ({
    type: CRUD_DELETE,
    payload: { params },
    meta: {
        menu: menu.toUpperCase(),
        fetch: DELETE,
        fetchMethod: 'post',
        onSuccess: {
            notification: {
                body: "common.delete.success",
                level: 'info',
            },
            redirectTo: redirectTo,
            refresh: {},
        },
        onFailure: {
            notification: {
                body: "common.delete.failure",
                level: 'warning',
            },
            refresh: {},
        },
    },
});

/**
 * 복수개의 데이타 삭제 action (메일 삭제)
 * @param {string} menu : 'DOCUMENT'
 * @param {Object} params : request요청 시 보낼 파라미터 
 */
export const crudDeleteMany = (menu, params) => {
    const menuUpperCase = menu.toUpperCase();
    let selectedCnt = 0;
    switch (menuUpperCase) {
        case 'DOCUMENT.FILE': 
            selectedCnt = params.ids.length;
            break;
        default: 
    }

    return ({
        type: CRUD_DELETE_MANY,
        payload: { params },
        meta: {
            menu: menu.toUpperCase(),
            fetch: DELETE_MANY,
            fetchMethod: 'post',
            onSuccess: {
                notification: {
                    body: (selectedCnt > 0 ? menu.toLowerCase() : "common") + ".delete.success",
                    requestMsgArgs: {},
                    level: 'info',
                },
                refresh: {},
                unselectAll: {},
            },
            onFailure: {
                notification: {
                    body: "common.delete.failure",
                    level: 'warning',
                },
                refresh: {},
                unselectAll: {},
            },
        },
    });
}

/**
 * 복수개의 데이타에 대해 이동(복사) 처리 action
 * 참고) params.type : move/copy
 * @param {Object} params : request요청 시 보낼 파라미터  
 */
export const crudMoveMany = (menu, params) => {
    // 성공/실패메세지 생성 
    const type = params.type;
    const menuUpperCase = menu.toUpperCase();
    const menuLowerCase = menu.toLowerCase();
    const selectedCnt = params.mailUserSeqs ? params.mailUserSeqs.length : 0;

    return ({
        type: CRUD_MOVE_MANY,
        payload: { params },
        meta: {
            menu: menuUpperCase,
            fetch: MOVE_MANY,
            fetchMethod: 'post',
            onSuccess: {
                notification: {
                    body: `${menuLowerCase}.${type}.success`,
                    requestMsgArgs: { cnt: selectedCnt, target: params.displayName },
                    level: 'info',
                },
                refresh: {},
                unselectAll: {},
            },
            onFailure: {
                notification: {
                    body: `${menuLowerCase}.${type}.failure`,
                    level: 'warning',
                },
            },
        },
    });
}

/**
 * 리셋 처리 action (ex. 비밀번호 오류 횟수 리셋)
 * @param {Object} params : request요청 시 보낼 파라미터  
 */
export const crudReset = (menu, params) => {
    // 성공/실패메세지 생성 
    const menuUpperCase = menu.toUpperCase();
    const menuLowerCase = menu.toLowerCase();

    return ({
        type: CRUD_RESET,
        payload: { params },
        meta: {
            menu: menuUpperCase,
            fetch: RESET,
            fetchMethod: 'post',
            onSuccess: {
                notification: {
                    body: `${menuLowerCase}.reset.success`,
                    level: 'info',
                },
                refresh: {},
                //unselectAll: {},
            },
            onFailure: {
                notification: {
                    body: `${menuLowerCase}.reset.failure`,
                    level: 'warning',
                },
            },
        },
    });
}

export const crudCreateForMultipart = (menu, params) => ({
    type: CRUD_CREATE,
    payload: { params },
    meta: { 
        menu: menu.toUpperCase(),
        fetch: CREATE,
        fetchMethod: 'post',
        multipart:true,
        //auth: true,
        onSuccess: {
            notification: {
                body: "common.save.success",
                level: 'info',
                popup: false,
            }
        },
        onFailure: {
            notification: {
                body: "common.save.failure",
                level: 'warning',
            },
        },
    }
});

export const extractTagsFromFile = (menu, params) => ({
    type: CRUD_CREATE,
    payload: { params },
    meta: { 
        menu: menu.toUpperCase(),
        fetch: CREATE,
        fetchMethod: 'post',
        multipart:true,
        //auth: true,
        onSuccess: {
            notification: {
                body: "document.file.tags.input.success",
                level: 'info',
                popup: false,
            }
        },
        onFailure: {
            notification: {
                body: "document.file.tags.input.failure",
                level: 'warning',
            },
        },
    }
});
